import type { QueryClient } from '@tanstack/react-query';

// Public widget configuration contains no account data. Keep its active observer
// intact during login; removing it briefly empties the reservation categories.
export function clearAccountQueries(client: QueryClient) {
  client.removeQueries({ predicate: query => !(
    query.queryKey[0] === 'public-booking' && query.queryKey[2] === 'widget'
  ) });
  client.getMutationCache().clear();
}
